import { render, staticRenderFns } from "./BuildingConnections.vue?vue&type=template&id=7630a6c4&scoped=true"
import script from "./BuildingConnections.vue?vue&type=script&lang=js"
export * from "./BuildingConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7630a6c4",
  null
  
)

export default component.exports